<template>
  <div>
    <div v-if="translatedContent">
      <div class="text-xs font-italic mb-1 translation-info">
        {{$t('comments.autoTranslatedComment')}}
        <span @click="toggleToOriginalLang = !toggleToOriginalLang" class="pointer translation-info-link">
          <span v-if="!toggleToOriginalLang">
            {{$t('comments.viewInOriginalLanguage')}} (<span class="text-uppercase">{{source}}</span>)</span>
          <span v-else>{{$t('comments.viewTranslatedComment')}}</span>
        </span>
      </div>
      <div v-html="toggleToOriginalLang ? content : translatedContent"></div>
    </div>
    <div v-else v-html="content"></div>
  </div>
</template>
<script>
import axios from 'axios';
import { GOOGLE_TRANSLATE_URL, GOOGLE_TRANSLATE_API_KEY } from '../config';

export default {
  props: {
    content: String,
    source: String,
    target: String,
  },
  data() {
    return {
      translatedContent: '',
      toggleToOriginalLang: false,
    };
  },
  mounted() {
    this.translateContent();
  },
  methods: {
    translateContent() {
      const url = `${GOOGLE_TRANSLATE_URL}?key=${GOOGLE_TRANSLATE_API_KEY}`;
      const params = {
        q: [this.content],
        target: this.formatLanguageCodeForTranslation(this.target),
        source: this.source ? this.formatLanguageCodeForTranslation(this.source) : '',
      };
      axios.post(url, params).then((result) => {
        if (result.data?.data?.translations[0]?.translatedText) {
          this.translatedContent = result.data.data.translations[0].translatedText;
        }
      });
    },
  },
};
</script>
